import React, { useState, useEffect } from 'react';
import './Sidebar.css';

function Sidebar({
  userType,
  activePage,
  onPageChange,
  user,
  isImpersonating = false,
  onReturnToAdmin,
  isOpen = true,
  onClose
}) {
  const [isMobile, setIsMobile] = useState(false);

  // Mobil kontrolü
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const studentMenuItems = [
    { id: 'home', label: 'Ana Sayfa' },
    { id: 'courses', label: 'Derslerim' },
    { id: 'calisma-konulari', label: 'Çalışma Konuları' },
    { id: 'odevler', label: 'Ödevler' },
    { id: 'exams', label: 'Sınavlarım' },
    { id: 'results', label: 'Sonuçlarım' },
    { id: 'kaynak-onerileri', label: 'Kaynak Önerileri' },
    { id: 'profile', label: 'Bilgilerim' },
  ];

  const instructorMenuItems = [
    { id: 'home', label: 'Ana Sayfa' },
    { id: 'courses', label: 'Derslerim', group: 'Ders Yönetimi' },
    { id: 'students', label: 'Öğrenciler', group: 'Ders Yönetimi' },
    { id: 'calisma-konulari', label: 'Çalışma Konuları', group: 'İçerik ve Değerlendirme' },
    { id: 'sorular', label: 'Sorular', group: 'İçerik ve Değerlendirme' },
    { id: 'odevler', label: 'Ödevler', group: 'İçerik ve Değerlendirme' },
    { id: 'exams', label: 'Sınav Yönetimi', group: 'İçerik ve Değerlendirme' },
    { id: 'statistics', label: 'Ders İstatistikleri', group: 'Analiz' },
    { id: 'profile', label: 'Bilgilerim' },
  ];

  const adminMenuItems = [
    { id: 'home', label: 'Ana Sayfa' },
    { id: 'exam-schedule', label: 'Sınav Takvimi' },
    { id: 'users', label: 'Akademisyenler' },
    { id: 'students', label: 'Öğrenciler' },
    { id: 'courses', label: 'Dersler' },
    { id: 'universite-raporu', label: 'Üniversite Raporu' },
    { id: 'akademisyen-raporu', label: 'Akademisyen Raporu' },
    { id: 'profile', label: 'Bilgilerim' },
  ];

  const programBaskanMenuItems = [
    { id: 'home', label: 'Ana Sayfa', group: 'Yönetim' },
    { id: 'students', label: 'Öğrenciler', group: 'Yönetim' },
    { id: 'courses', label: 'Dersler', group: 'Yönetim' },
    { id: 'exams', label: 'Sınav Yönetimi', group: 'Yönetim' },
    { id: 'sorular', label: 'Sorular', group: 'Yönetim' },
    { id: 'odevler', label: 'Ödevler', group: 'Yönetim' },
    { id: 'calisma-konulari', label: 'Çalışma Konuları', group: 'Yönetim' },
    { id: 'sinav-raporlari', label: 'Sınav Raporları', group: 'Raporlar' },
    { id: 'akademisyen-siralama', label: 'Akademisyen Etkinliği', group: 'Raporlar' },
  ];

  const rektorMenuItems = [
    { id: 'home', label: 'Ana Sayfa', group: 'Üniversite Görünümü' },
    { id: 'students', label: 'Öğrenciler', group: 'Üniversite Görünümü' },
    { id: 'courses', label: 'Dersler', group: 'Üniversite Görünümü' },
    { id: 'sinav-raporu', label: 'Üniversite Sınav Raporları', group: 'Kurum Raporları' },
    { id: 'akademisyen-sinav-raporu', label: 'Akademisyen Etkinliği', group: 'Kurum Raporları' },
    { id: 'statistics', label: 'Üniversite İstatistikleri', group: 'Kurum Raporları' },
    { id: 'calisma-konulari', label: 'Çalışma Konuları', group: 'İzleme' },
    { id: 'odevler', label: 'Ödevler', group: 'İzleme' },
    { id: 'sorular', label: 'Sorular', group: 'İzleme' },
  ];

  const allMenuItems = userType === 'student'
    ? studentMenuItems
    : userType === 'admin'
    ? adminMenuItems
    : userType === 'program_baskan'
    ? programBaskanMenuItems
    : (userType === 'rektor' || userType === 'rektor_yardimcisi')
    ? rektorMenuItems
    : instructorMenuItems;
  // Bilgilerim şimdilik sidebar'da gizli (silinmedi)
  const menuItems = allMenuItems.filter((item) => item.id !== 'profile');
  const menuGroupOrder = userType === 'program_baskan'
    ? ['Yönetim', 'Raporlar']
    : userType === 'instructor'
    ? [null, 'Ders Yönetimi', 'İçerik ve Değerlendirme', 'Analiz']
    : (userType === 'rektor' || userType === 'rektor_yardimcisi')
    ? ['Üniversite Görünümü', 'Kurum Raporları', 'İzleme']
    : [null];
  const menuGroups = menuGroupOrder.map((label) => ({
      label,
      items: menuItems.filter((item) => (item.group || null) === label),
    })).filter((group) => group.items.length > 0);

  const handleMenuItemClick = (pageId) => {
    onPageChange(pageId);
  };

  // Kullanıcı tipine göre buton metnini belirle
  const getButtonText = () => {
    if (userType === 'student') {
      return 'Öğrenci';
    } else if (userType === 'instructor') {
      return 'Akademisyen';
    } else if (userType === 'admin') {
      return 'Admin';
    } else if (userType === 'program_baskan') {
      return 'Program Başkanı';
    } else if (userType === 'rektor') {
      return 'Rektör';
    } else if (userType === 'rektor_yardimcisi') {
      return 'Rektör Yardımcısı';
    }
    return 'Kullanıcı';
  };

  // Mobil için ayrı sidebar render
  if (isMobile && onClose) {
    return (
      <>
        {/* Mobil overlay - sidebar açıkken arka planı karart */}
        {isOpen && <div className="mobile-sidebar-overlay" onClick={onClose} />}
        
        {/* Mobil Sidebar - Yukarıdan gelir */}
        <div className={`mobile-sidebar-container ${isOpen ? 'open' : ''}`}>
          <div className="mobile-sidebar">
            <div className="mobile-sidebar-header">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                <button className="mobile-sidebar-dean-button">
                  {getButtonText()}
                </button>
                <button
                  onClick={onClose}
                  className="mobile-sidebar-close-button"
                  aria-label="Menüyü Kapat"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              {user?.faculty && <div className="mobile-sidebar-school-info">{user.faculty}</div>}
            </div>
            
            <nav className="mobile-sidebar-nav">
              {menuGroups.map((group) => (
                <div className="mobile-sidebar-menu-group" key={group.label || 'main'}>
                  {group.label && <div className="mobile-sidebar-menu-heading">{group.label}</div>}
                  <ul className="mobile-sidebar-menu">
                    {group.items.map((item) => (
                      <li key={item.id}>
                        <button
                          className={`mobile-sidebar-menu-item ${activePage === item.id ? 'active' : ''}`}
                          onClick={() => {
                            handleMenuItemClick(item.id);
                            onClose();
                          }}
                        >
                          <span className="menu-label">{item.label}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </nav>

            {isImpersonating && onReturnToAdmin && (
              <div className="sidebar-impersonation-box mobile">
                <div className="sidebar-impersonation-title">Admin oturumu aktif</div>
                <div className="sidebar-impersonation-text">
                  Mevcut hesaptan çıkmadan admin paneline geri dönebilirsiniz.
                </div>
                <button
                  type="button"
                  className="sidebar-return-admin-button"
                  onClick={() => {
                    onReturnToAdmin();
                    onClose();
                  }}
                >
                  Admin hesabına dön
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  // Desktop Sidebar - Normal sidebar (değişiklik yok)
  return (
    <>
      {/* Mobil overlay - sidebar açıkken arka planı karart */}
      {isOpen && onClose && <div className="sidebar-overlay" onClick={onClose} />}
      
      <div className={`sidebar-container ${isOpen ? 'open' : ''}`}>
        {/* Ana Sidebar */}
        <div className="sidebar">
        <div className="sidebar-header">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <button className="sidebar-dean-button" style={{ flex: 1, marginRight: '0.5rem' }}>
              {getButtonText()}
            </button>
            {onClose && (
              <button
                onClick={onClose}
                className="sidebar-close-button"
                aria-label="Menüyü Kapat"
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  padding: '0.5rem',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.1)'}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            )}
          </div>
          {user?.faculty && <div className="sidebar-school-info">{user.faculty}</div>}
        </div>
        
        <nav className="sidebar-nav">
          {menuGroups.map((group) => (
            <div className="sidebar-menu-group" key={group.label || 'main'}>
              {group.label && <div className="sidebar-menu-heading">{group.label}</div>}
              <ul className="sidebar-menu">
                {group.items.map((item) => (
                  <li key={item.id}>
                    <button
                      className={`sidebar-menu-item ${activePage === item.id ? 'active' : ''}`}
                      onClick={() => handleMenuItemClick(item.id)}
                    >
                      <span className="menu-label">{item.label}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        {isImpersonating && onReturnToAdmin && (
          <div className="sidebar-impersonation-box">
            <div className="sidebar-impersonation-title">Admin oturumu aktif</div>
            <div className="sidebar-impersonation-text">
              Mevcut hesaptan çıkmadan admin paneline geri dönebilirsiniz.
            </div>
            <button
              type="button"
              className="sidebar-return-admin-button"
              onClick={onReturnToAdmin}
            >
              Admin hesabına dön
            </button>
          </div>
        )}
      </div>
    </div>
    </>
  );
}

export default Sidebar;
